import { QuestionPlanIsUnchangeable as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-unchangeable";

import { useDayTripPlanIsUnchangeable } from "./hooks";

export const QuestionDayTripPlanIsUnchangeable = () => {
	const { isUnchangeable, onSetIsUnchangeable } = useDayTripPlanIsUnchangeable();

	return <Question isUnchangeable={isUnchangeable} onSetIsUnchangeable={onSetIsUnchangeable} />;
};

QuestionDayTripPlanIsUnchangeable.displayName = "QuestionDayTripPlanIsUnchangeable";
